module.exports = __webpack_public_path__ + "static/media/google-play-dw-icon.6ffe0442.png";